/* eslint-env browser */
import 'babel-polyfill';

import AulaNextProvider from '@ublend-npm/aulaui-next-web/components/Provider/Provider';
import { Provider as AulaThemeProvider } from '@ublend-npm/aulaui';
import React from 'react';
import { StyleRoot } from 'radium';
import { Provider } from 'react-redux';
import { Router, Route, IndexRedirect, hashHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { configure as configureHotkeys } from 'react-hotkeys';

import Parse from './utils/parse';
import App from './components/presentational/App.container';
import DashboardRoute from './routes/Dashboard';
import LogoutRoute from './routes/Logout';
import FilesRoute from './routes/Files';
import { configureStore } from './store';
import { fetchLocalUser, fetchCurrentUser } from '../core/actions/user';
import { loginWithAuthCookie, authMigrator } from '../core/actions/user/login';
import { fetchLocation } from '../core/actions/location';
import { fetchInstitution } from '../core/actions/institutions';
import {
  analyticsTrackEvent,
  init as analyticsInit,
} from '../core/utils/analytics';
import { getQueryString } from '../core/utils/queryParams';
import * as analyticsTypes from '../core/constants/analytics';
import fetchProviders from '../core/actions/lti/fetch';
import Raven from '../core/utils/raven';
import Platform from '../core/utils/platform';

import './fonts/font.css';

configureHotkeys({
  ignoreEventsCondition: () => false,
});

const redirectToGeneral = () => {
  const redirect = encodeURIComponent(window.location.href);
  const loginUrl = window.location.href.includes('localhost')
    ? `http://localhost:8888/?redirect=${redirect}`
    : `https://general.aula.education/?redirect=${redirect}`;
  return window.location.replace(loginUrl);
};

const loadApp = async (store) => {
  const host = window.location.hostname.split('.');
  const institution =
    process.env.INSTITUTION || (host[0] === 'beta' ? host[1] : host[0]);
  await store.dispatch(fetchInstitution(institution));

  const institutionData = store.getState().institution;

  const { parse } = institutionData.keys;
  Parse.initialize(parse.appId, parse.javascriptKey);
  Parse.serverURL = parse.serverURL;

  authMigrator();
  const loginEvent = getQueryString('login');

  const user = await store.dispatch(
    loginWithAuthCookie(getQueryString('email'))
  );
  if (user.error) {
    return redirectToGeneral();
  }
  if (!user) {
    store.dispatch(fetchLocalUser());
  }

  try {
    await fetchCurrentUser(store.getState());
  } catch (_) {
    redirectToGeneral();
  }

  await analyticsInit(store.getState);
  if (loginEvent === 'true') {
    analyticsTrackEvent(analyticsTypes.CODE_LOGIN);
  }

  Raven.configureScope((scope) => {
    if (
      store.getState() &&
      store.getState().user &&
      store.getState().user.user
    ) {
      scope.setUser(store.getState().user.user);
    }
  });

  Raven.setTags({
    institution: institutionData.general.institution,
    Platform,
  });

  store.dispatch(fetchProviders());

  return store;
};

const WebApp = async () => {
  const store = configureStore();
  await loadApp(store);

  store.dispatch(fetchLocation());
  const history = syncHistoryWithStore(hashHistory, store);

  return (
    <AulaThemeProvider>
      <AulaNextProvider>
        <StyleRoot>
          <Provider store={store}>
            <Router history={history}>
              <Route path="/" component={App}>
                {LogoutRoute}
                {DashboardRoute}
                {FilesRoute}
                <IndexRedirect to="dashboard" />
              </Route>
            </Router>
          </Provider>
        </StyleRoot>
      </AulaNextProvider>
    </AulaThemeProvider>
  );
};

export default WebApp;
